import { hideOffer } from './hideOffer';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { TThunkAction } from '../../types/redux';
import { requestAuthentication } from '../authentication/requestAuthentication';

export const onHideOffer =
  (offer: IDailyRentOfferForMobileSite): TThunkAction =>
  (dispatch, getState) => {
    const { user } = getState();

    if (user.isAuthenticated) {
      dispatch(hideOffer(offer));

      return;
    }

    dispatch(
      requestAuthentication({
        source: 'hideOffers',
        viewData: { headingType: 'hideOffers' },
        onSuccess: (): TThunkAction => dispatch => {
          dispatch(hideOffer(offer));
        },
      }),
    );
  };
